import React from 'react'
import { Microphone } from '../OracleCommons/icons/Microphone'
import { MicrophoneOff } from '../OracleCommons/icons/MicrophoneOff'

interface OracleMicrophoneButtonProps {
  isMuted?: boolean
  onClick?: () => void
  disabled?: boolean
}

const OracleMicrophoneButton: React.FC<OracleMicrophoneButtonProps> = ({
  isMuted = false,
  onClick,
  disabled = false,
}) => {
  return (
    <div
      className={`oracle-microphone-button ${isMuted ? 'oracle-microphone-button--muted' : ''} ${disabled ? 'oracle-microphone-button--disabled' : ''}`}
      onClick={disabled ? undefined : onClick}
      data-color="Purple Ashes"
      data-label="false"
      data-left-icon="false"
      data-right-icon="true"
      data-size="Large"
      data-state="Default"
      data-type="Purple"
    >
      <div
        className={`oracle-microphone-button__icon-wrapper ${isMuted ? 'oracle-microphone-button__icon-wrapper--muted' : ''}`}
        data-icon={isMuted ? 'Mic off' : 'Mic'}
        data-style="Outline"
      >
        {isMuted ? (
          <MicrophoneOff
            size="20px"
            color="var(--Extended-N90, #373B43)"
          />
        ) : (
          <Microphone
            size="20px"
            color="var(--Extended-P70-BRAND, #71428B)"
          />
        )}
      </div>
    </div>
  )
}

export default OracleMicrophoneButton
